import React, { createContext, useContext } from 'react';

interface ExperimentSharedContextData {
  experiment: string;
  value: string | boolean;
}

const ExperimentSharedContext = createContext<ExperimentSharedContextData>(
  {} as ExperimentSharedContextData
);

interface ExperimentSharedProviderProps extends ExperimentSharedContextData {
  children: React.ReactNode;
}

const ExperimentSharedProvider: React.FC<ExperimentSharedProviderProps> = ({
  experiment,
  value,
  children,
}: ExperimentSharedProviderProps) => {
  return (
    <ExperimentSharedContext.Provider value={{ experiment, value }}>
      {children}
    </ExperimentSharedContext.Provider>
  );
};

/**
 * Use this hook to get the experiment and value from the shared context, in any component that is part of the page
 */
const useExperimentSharedContext = (): ExperimentSharedContextData =>
  useContext(ExperimentSharedContext);

export { useExperimentSharedContext, ExperimentSharedProvider };
